export default (cookieName, cookieValue, domain, expiry) => {
    document.cookie = `${cookieName}=${cookieValue};domain=${domain};path=/;expires=${expiry};`;
};
